import * as React from 'react';
import { connect } from 'react-redux';
import DispatchProps, { mapDispatchToProps } from '../../application/core/DispatchProps';
import { ChangeEvent } from 'react';
import './Login.css';
import logo from '../img/HappySocks-Logo-45px.svg';
import SendForgotPasswordEmailRequested from '../../application/user/events/SendForgotPasswordEmailRequested';
import { emailRegex } from './regexPatterns';
import background from '../img/SS19-HappySocks-Showroom-Background-1600x500.png';

interface State {
    email: string;
    emailErrorMessage: string;
}

interface StateProps {
    errorMessage: string;
}

class ForgotPassword extends React.PureComponent<DispatchProps & StateProps, State> {
    constructor(props: DispatchProps & StateProps) {
        super(props);
        this.state = {
            email: '',
            emailErrorMessage: ''
        };
    }

    public render(): JSX.Element {
        return (
            <div>
                <div className="login">
                    <div className="login-form">
                        <h1>Happysocks showroom</h1>
                        <label htmlFor="email">Email:</label>
                        <input name="email" onChange={this.onEmailChanged} />
                        {this.state.emailErrorMessage && <span className="login-error-message">{this.state.emailErrorMessage}</span>}
                        {this.props.errorMessage && <span className="login-error-message">{this.props.errorMessage}</span>}
                        <button className="login-submit-button" onClick={this.onSendEmailButtonClicked}>
                            Send email
                        </button>
                    </div>
                </div>
                <div className="login-logo">
                    <img src={logo} />
                </div>
                <div className="login-triangle">
                    <img src={background} />
                </div>
            </div>
        );
    }

    private onEmailChanged = (event: ChangeEvent<HTMLInputElement>): void =>
        this.setState({
            email: event.currentTarget.value
        });

    private checkEmailAddress = (): boolean => {
        return emailRegex.test(this.state.email);
    };

    private onSendEmailButtonClicked = (): void => {
        if (this.checkEmailAddress()) {
            this.setState({ emailErrorMessage: '' });
            this.props.dispatch(new SendForgotPasswordEmailRequested(this.state.email));
        } else {
            this.setState({ emailErrorMessage: 'Invalid email address' });
        }
    };
}

export default connect(mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/view/login/ForgotPassword.tsx